import { TabsClasses, Theme } from '@mui/material';
import { OverridesStyleRules } from '@mui/material/styles/overrides';

export const MUI_TABS_OVERRIDES: Partial<OverridesStyleRules<keyof TabsClasses, 'MuiTabs', Theme>> =
  {
    root: ({ theme }) => ({
      padding: theme.spacing(0, 3.125),
      height: '100%',
    }),
  };
